import { Table } from '@mui/material'
import { TableHead } from '@mui/material'
import { TableCell } from '@mui/material'
import { TableBody } from '@mui/material'
import { TableRow } from '@mui/material'
import { TablePagination } from '@mui/material'
import { TableContainer, Paper } from '@mui/material'
import React from 'react'
import AdminControllButtons from '../../UI/Admin/AdminControllButtons/AdminControllButtons'
import EmptyData from '../../UI/Admin/EmpyData/EmptyData'
import TableTh from '../../UI/Table/TableTh/TableTh'
import classes from '../AdminView.module.css'
import moment from 'moment'

const News = (props) => {
    const {
        news,
        pageSize,
        pageNumber,
        total,
        handleChangePage,
        handlePageSize,
        handleRemove,
        handleEdit,
        searchValue,
        getNews
    } = props

    const rows = [
        {
            key: 'photo',
            text: "Poster",
            searchByValue: ""
        },
        {
            key: 'title',
            text: "Title",
            searchByValue: "title"
        },
        {
            key: 'date',
            text: "Date",
            searchByValue: "created_at"
        },
        {
            key: '',
            text: "",
            searchByValue: ""
        }
    ]

    return (
        <div className={classes.main}>
            <TableContainer component={Paper} className={classes.table}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {rows.map(item => (
                                <TableTh
                                    key={item.key}
                                    text={item.text}
                                    onSort={getNews}
                                    searchByValue={item.searchByValue}
                                    searchValue={searchValue}
                                    pageNumber={pageNumber}
                                    pageSize={pageSize}
                                />
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {news.map(item => (
                            <TableRow key={item._id}>
                                <TableCell width={"100px"}>
                                    <img src={item.image} alt="poster" className={classes.imgPreview}/>
                                </TableCell>
                                <TableCell>{item.title}</TableCell>
                                <TableCell width={"25%"}>{moment(item.created_at).format('DD/MM/YYYY')}</TableCell>
                                <TableCell width={120}>
                                    <AdminControllButtons
                                        item={item}
                                        onRemove={handleRemove}
                                        onEdit={handleEdit}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {news.length === 0 && <EmptyData/>}
            <TablePagination
                rowsPerPageOptions={[5, 10, 20, 50]}
                component={"div"}
                rowsPerPage={pageSize}
                page={pageNumber}
                count={total}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handlePageSize}
                className={classes.pagination}
            />
        </div>
    )
}

export default News